<div class="form-group-flex-column">
  <mat-label [ngClass]="required ? 'required-field-after' : ''">{{ label }}</mat-label>
  <mat-form-field [ngClass]="classCss" appearance="outline">
    <input [(ngModel)]="value"
           [disabled]="disabled"
           [matDatepicker]="dp"
           [required]="required"
           data-lpignore="true"
           matInput>
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker #dp
                    (monthSelected)="chosenMonthHandler($event, dp)"
                    startView="multi-year">
    </mat-datepicker>
    <mat-error *ngIf="error.length > 0">
      {{ error }}
    </mat-error>
  </mat-form-field>
</div>
